/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_BrandingPackageDto } from '../models/PagedResultDto_BrandingPackageDto';
import type { Wealthlane_Dtos_BrandingPackage_BrandingPackageDto } from '../models/Wealthlane_Dtos_BrandingPackage_BrandingPackageDto';
import type { Wealthlane_Dtos_BrandingPackage_CreateUpdateBrandingPackageDto } from '../models/Wealthlane_Dtos_BrandingPackage_CreateUpdateBrandingPackageDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BrandingPackageService {

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiBrandingPackage(
        requestBody?: Wealthlane_Dtos_BrandingPackage_CreateUpdateBrandingPackageDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/branding-package',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_BrandingPackageDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiBrandingPackage(
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_BrandingPackageDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/branding-package',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiIdentityApiBrandingPackage(
        id: string,
        requestBody?: Wealthlane_Dtos_BrandingPackage_CreateUpdateBrandingPackageDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/api/branding-package/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_Dtos_BrandingPackage_BrandingPackageDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiBrandingPackage1(
        id: string,
    ): CancelablePromise<Wealthlane_Dtos_BrandingPackage_BrandingPackageDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/branding-package/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Dtos_BrandingPackage_BrandingPackageDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiBrandingPackageDefault(): CancelablePromise<Wealthlane_Dtos_BrandingPackage_BrandingPackageDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/branding-package/default',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiIdentityApiBrandingPackageSetDefault(
        id: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/api/branding-package/{id}/set-default',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiBrandingPackageUploadLogo(
        formData?: {
            File?: Blob;
            ImageLink?: string;
        },
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/branding-package/upload-logo',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
